import { useMemo, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const FORMATS = [
  "header", "bold", "italic", "underline", "align", "list",
  "indent", "link", "color", "background", "size",
];

export default function RichTextEditor({ value, onChange, placeholder, testid }) {
  const ref = useRef(null);

  const modules = useMemo(() => ({
    history: { delay: 500, maxStack: 200, userOnly: true },
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        [{ size: ["small", false, "large"] }],
        ["bold", "italic", "underline"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "clean"],
        ["undo", "redo"],
      ],
      handlers: {
        undo() { this.quill.history.undo(); },
        redo() { this.quill.history.redo(); },
      },
    },
  }), []);

  return (
    <div className="rte" data-testid={testid}>
      <ReactQuill ref={ref} theme="snow" value={value || ""} onChange={onChange}
        modules={modules} formats={FORMATS} placeholder={placeholder} />
    </div>
  );
}
